import { FC, SVGProps } from 'react'

export const ShoppingBag: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M20.36 6.56H16.56C16.56 5.35061 16.0796 4.19076 15.2244 3.33559C14.3692 2.48043 13.2094 2 12 2C10.7906 2 9.63075 2.48043 8.77559 3.33559C7.92042 4.19076 7.43999 5.35061 7.43999 6.56H3.63999C3.23687 6.56 2.85025 6.72014 2.56519 7.0052C2.28014 7.29025 2.12 7.67687 2.12 8.08V19.48C2.12 19.8831 2.28014 20.2697 2.56519 20.5548C2.85025 20.8399 3.23687 21 3.63999 21H20.36C20.7631 21 21.1497 20.8399 21.4348 20.5548C21.7199 20.2697 21.88 19.8831 21.88 19.48V8.08C21.88 7.67687 21.7199 7.29025 21.4348 7.0052C21.1497 6.72014 20.7631 6.56 20.36 6.56ZM12 3.52C12.8063 3.52 13.5795 3.84028 14.1496 4.4104C14.7197 4.98051 15.04 5.75374 15.04 6.56H8.95999C8.95999 5.75374 9.28028 4.98051 9.85039 4.4104C10.4205 3.84028 11.1937 3.52 12 3.52ZM20.36 19.48H3.63999V8.08H20.36V19.48Z"
			fill="currentColor"
		/>
	</svg>
)
